import { createContext } from 'react';
import { ControllerType } from '@/types/ControllerType';

export const HookFormContext = createContext<{ controller?: ControllerType }>({ controller: undefined });
